"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const styles_styled_1 = require("./styles.styled");
const SsoHeader_1 = __importDefault(require("../SsoHeader"));
const helpers_1 = require("../../helpers");
const SsoBottomLinks_1 = __importDefault(require("../SsoBottomLinks"));
const Modal = ({ children, open, onClose, width, isFullScreen = false, isBottom = false, modalKey, withLayout = true, setIsSsoModalOpen, isNested = false, }) => {
    const { isMobile, isDesktop, locale, fullPage } = (0, styled_components_1.useTheme)();
    const defaultsStyle = {
        style: {
            width,
            maxWidth: isMobile && !isFullScreen ? "100%" : "auto",
            height: isFullScreen && !isBottom ? "100%" : "auto",
            overflowY: isDesktop && !isFullScreen ? "initial" : "auto",
            background: "#fff",
            textAlign: locale === "ar" ? "right" : "left",
            borderRadius: !isFullScreen
                ? "8px"
                : isBottom
                    ? "20px 20px 0 0"
                    : "unset",
            position: isBottom ? "absolute" : "unset",
            left: 0,
            bottom: 0,
            fontSize: "16px",
        },
    };
    (0, react_1.useEffect)(() => {
        if (isMobile && (0, helpers_1.isBrowser)() && typeof navigator !== "undefined" && (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes("iPhone"))) {
            let prevScrollPosition = window.scrollY;
            // Add or remove class to body element based on dialog open state
            if (!isNested) {
                if (open) {
                    prevScrollPosition = window.scrollY;
                    document.querySelector("html").style.overflow = "hidden";
                    document.querySelector("html").style.height = "100%";
                    document.body.style.height = "100%";
                }
                else {
                    document.querySelector("html").removeAttribute("style");
                    document.body.removeAttribute("style");
                    window.scrollTo(0, prevScrollPosition);
                }
                // Clean up the effect when the component unmounts or the dependency changes
                return () => {
                    document.querySelector("html").removeAttribute("style");
                    document.body.removeAttribute("style");
                    window.scrollTo(0, prevScrollPosition);
                };
            }
        }
    }, [open]);
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, fullScreen: isFullScreen, onClose: onClose, maxWidth: false, PaperProps: defaultsStyle, scroll: isDesktop ? "body" : "paper", hideBackdrop: fullPage, transitionDuration: 0 }, { children: (0, jsx_runtime_1.jsx)(styles_styled_1.SsoWrapper, Object.assign({}, (0, helpers_1.classNames)(isFullScreen && !isBottom && "fullScreenHeight"), { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)(isFullScreen &&
                "flex flexDirectionColumn alignItems flexSpaceBetween justifyContent", isMobile && "grayBg", !isBottom && isFullScreen && "height-100"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)(isFullScreen && "width-100"), { children: [withLayout && !isBottom && ((0, jsx_runtime_1.jsx)(SsoHeader_1.default, { setIsSsoModalOpen: setIsSsoModalOpen })), children] })), isFullScreen && withLayout && !isBottom && (0, jsx_runtime_1.jsx)(SsoBottomLinks_1.default, {})] })) })) }), modalKey));
};
exports.default = Modal;
